module.exports = __webpack_public_path__ + "img/patientgroup.d40cc90f.svg";